import TemporizadorActualizar from "../TemporizadorActualizar/TemporizadorActualizar";
import "./TokenBox.css";
import base32 from "hi-base32";
import * as OTPAuth from "otpauth";
import { useEffect, useState } from "react";

const TokenBox = () => {
  const [tokenActual, setTokenActual] = useState();
  const [tokenSeparadoIzquierda, setTokenSeparadoIzquierda] = useState();
  const [tokenSeparadoDerecha, setTokenSeparadoDerecha] = useState();
  let config = localStorage.getItem("config");
  let secretKeyTotp = JSON.parse(config).secretKeyTotp;

  useEffect(() => {
    onChangeTemporizador();
  }, []);

  const onChangeTemporizador = () => {
    const obtenerTokenStorage = async () => {
      const itemStorage = localStorage.getItem("dtoSegundoFactor");
      const itemToken = JSON.parse(itemStorage);
      if (itemToken) {
        const totp = new OTPAuth.TOTP({
          issuer: "ACME",
          label: "AzureDiamond",
          algorithm: "SHA1",
          digits: 6,
          period: 60,
          secret: base32.encode(
            secretKeyTotp + itemToken.usuario + itemToken.token
          ),
        });
        setTokenActual(totp.generate());
      }
    };
    obtenerTokenStorage();
  };

  useEffect(() => {
    if (tokenActual) {
      setTokenSeparadoIzquierda(tokenActual.slice(0, 3));
      setTokenSeparadoDerecha(tokenActual.slice(3, 6));
    }
  }, [tokenActual]);

  return (
    <div className="tokenbox">
      <div className="tokenbox-title rb18b">
        <span>2FA DIM</span>
      </div>
      <div className="tokenbox-body">
        <div className="tokenbox-body-token">
          <span className="tokenbox-mitad noSeleccionable c-black rb52t">
            {tokenSeparadoIzquierda}
          </span>
          <span className="tokenbox-mitad noSeleccionable c-black rb52t">
            {tokenSeparadoDerecha}
          </span>
        </div>
        <div className="tokenbox-body-timer">
          <TemporizadorActualizar onChange={onChangeTemporizador} />
        </div>
      </div>
    </div>
  );
};
export default TokenBox;
